import { TextInput } from '@components/common';
import { ReactElement } from 'react';
import { MicroSiteFormProps } from '.';

export const MicroSiteForm = ({ data, index }: MicroSiteFormProps): ReactElement => {
	return (
		<section className="new-site-section-add">
			<div className="multi-input-box-border">
				<h3>Site {index}</h3>
				<form>
					<div className="inputs-wrap">
						<ul className="new-site-wrapper row">
							<li className="form-control d-col d-col-2">
								<TextInput
									id="siteName"
									name="siteName"
									type="text"
									value={data.siteName}
									label="Site Name"
									disabled={true}
									required
								/>
							</li>

							<li className="form-control d-col d-col-2">
								<TextInput
									id="siteLocation"
									name="siteLocation"
									type="text"
									value={data.siteLocation}
									label="Site Location"
									disabled={true}
								/>
							</li>
							<li className="form-control d-col d-col-2">
								<TextInput
									id="siteArea"
									name="siteArea"
									type="text"
									value={data.siteArea}
									label="Site Area"
									disabled={true}
								/>
							</li>
							<li className="form-control d-col d-col-2">
								<TextInput
									id="contractorName"
									name="contractorName"
									type="text"
									value={data.contractorName}
									label="Contractor Name"
									disabled={true}
								/>
							</li>
							<li className="form-control d-col d-col-2">
								<TextInput
									id="contractorNumber"
									name="contractorNumber"
									type="text"
									value={data.contractorNumber}
									label="Contractor Number"
									disabled={true}
								/>
							</li>
							<li className="form-control d-col d-col-2">
								<TextInput
									id="siteSpecialist"
									name="siteSpecialist"
									type="text"
									value={data.siteSpecialist}
									label="Site Specialist"
									disabled={true}
								/>
							</li>
							<li className="form-control d-col d-col-2">
								<TextInput
									id="superVisorName"
									name="superVisorName"
									type="text"
									value={data.superVisorName}
									label="Site In Charge Name"
									disabled={true}
								/>
							</li>
							<li className="form-control d-col d-col-2">
								<TextInput
									id="superVisorNumber"
									name="superVisorNumber"
									type="text"
									value={data.superVisorNumber}
									label="Site In Charge Number"
									disabled={true}
								/>
							</li>
						</ul>
					</div>
				</form>
			</div>
		</section>
	);
};
